import { jsx } from "react/jsx-runtime";
import { Button, buttonClasses, styled, useThemeProps } from "@mui/material";
import { forwardRef } from "react";
const editorToolbarButtonName = "TidalEditorToolbarButton";
const editorToolbarButtonClasses = buttonClasses;
const EditorToolbarButtonBase = forwardRef(
  function EditorToolbarButtonBase2(inProps, ref) {
    const props = useThemeProps({
      name: editorToolbarButtonName,
      props: inProps
    });
    const { testId = `${editorToolbarButtonName}-root`, variant = "text", ...rest } = props;
    return /* @__PURE__ */ jsx(Button, { ref, variant, "data-tidal": editorToolbarButtonName, "data-testid": testId, ...rest });
  }
);
const EditorToolbarButton = styled(EditorToolbarButtonBase, {
  name: editorToolbarButtonName,
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})(({ theme }) => ({
  color: (theme.vars ?? theme).palette.action.active,
  minWidth: "unset",
  textTransform: "none"
}));
export {
  EditorToolbarButton,
  editorToolbarButtonClasses,
  editorToolbarButtonName
};
//# sourceMappingURL=EditorToolbarButton.js.map
